import AutoNumeric from "autonumeric";
import {autonumericOptions} from "./autonumeric";


function createElementProject(add_button, object, index) {
    const regex = new RegExp(add_button.data('placeholder'), 'g');
    const templ2 = add_button.data('html')
    const html2 = templ2.replace(regex, index);


    let $html2 = $(html2)
    $html2.find('.has-many-remove').remove()
    $html2.find('.has-many-delete').remove()
    $html2.find('[id^=project_item_projects_attributes_][id$=_label]').val(object.label)
    $html2.find('[id^=project_item_projects_attributes_][id$=_item_id]').val(object.id)
    $html2.find('[id^=project_item_projects_attributes_][id$=amount]').attr('data-item-id', object.id)
    $html2.find('[id^=project_item_projects_attributes_][id$=amount]').attr('data-parent-id', object.parent_id)
    return $html2
}

function initPlanChange() {
    $('#project_plan_id').on('change', function (e) {
        $.getJSON(`/admin/projects/items?plan_id=${this.value}`, function (data) {
            const parent = $("form.project .has-many-container[data-has-many-association=\"item_projects\"]");
            $.each(parent.find('.inputs.has-many-fields'), function (i, object) {

                const c = $(object).find("[id^=project_item_projects_attributes_][id$=__destroy][value='1']")
                if (c.length > 0) {
                    $(object).hide();
                    $(object).find("[id^=project_item_projects_attributes_][id$=__destroy][value='1']").attr("checked", "checked")
                } else {
                    $(object).remove();
                }

            });
            const add_button = parent.find('.has-many-add')

            $.each(data.filter(x => x.level === 1), function (i, object) {

                let index = parseInt(parent.data('has_many_index') || (parent.find('fieldset').length - 1), 10);
                parent.data('has_many_index', ++index)
                let $html = createElementProject(add_button, object, index)
                $html.attr("placeholder", "Level1")

                $.each(data.filter(x => x.level === 2 && x.parent_id === object.id), function (i, object) {
                    let index = parseInt(parent.data('has_many_index'));
                    parent.data('has_many_index', ++index)
                    let wrapper = $("<li>", {class: "has-many-container", "data-has-many-association": "children"});
                    let $html2 = createElementProject(add_button, object, index)
                    $html2.attr("placeholder", "Level2")
                    wrapper.html($html2)

                    $.each(data.filter(x => x.level === 3 && x.parent_id === object.id), function (i, object) {
                        let index = parseInt(parent.data('has_many_index'));
                        parent.data('has_many_index', ++index)
                        let wrapper = $("<li>", {class: "has-many-container", "data-has-many-association": "children"});
                        let $html3 = createElementProject(add_button, object, index)
                        $html3.attr("placeholder", "Level3")
                        wrapper.html($html3)
                        $html2.find("> ol").append(wrapper)
                    });

                    $html.find("> ol").append(wrapper)
                });

                $html.insertBefore(add_button)
            });

            checkAmount();
            $(parent).trigger('has_many_add:after', [parent, parent]) // Aggiunta callback

        });
    })
}
function initProjectForm() {

    // FORM project - nascondo elementi già flaggati per l'eliminazione
    const formProject = $("form.project#edit_project")
    $.each(formProject.find('.inputs.has-many-fields'), function (i, object) {
        const el = $(object).find("[id^=project_item_projects_attributes_][id$=__destroy][value='1']")
        if (el.is(':checked')) {
            el.closest('.inputs.has-many-fields').hide()
        }
    });


    // CHANGE event plan
    initPlanChange();

}

// CONTROLLA coerenza importi di budget nell'alberatura delle voci di spesa, form project
function checkAmount() {
    const $form = $('form.project')

    const $fields = $form.find(".currency");
    $.each($fields, function (i, object) {

        $(object).on('change', function (e) {
            // CLEAR error
            $.each($fields, function (i, object) {
                const $target = $(object);
                const $container = $target.closest('.string.input');
                if ($container.hasClass('error-sum')) {
                    $container.removeClass('error-sum').removeClass('error')
                    $container.find("p.inline-errors").remove()
                    $target.unwrap();
                }
            });
            const parentFields = $fields.filter(function () {
                return $(this).data('parent-id') === undefined;
            });

            checkChild($fields, parentFields)
        });
    });

}

function checkChild(allFields, currentLevelFields) {
    $.each(currentLevelFields, function (i, ob) {
        // conteggio child
        const $currentElement = $(ob)
        const $currentElementContainer = $currentElement.closest('.string.input');
        const acParentElement = AutoNumeric.getAutoNumericElement(`#${$currentElement.attr('id')}`);
        const childID = $currentElement.data('item-id');
        const childFields = allFields.filter(function () {
            return $(this).data('parent-id') === childID;
        });
        let childTot = 0
        $.each(childFields, function (i, ob) {
            const cValue = AutoNumeric.getAutoNumericElement(`#${$(ob).attr('id')}`);
            childTot += cValue.getNumber() || 0
        });
        const formattedChildTot = AutoNumeric.format(childTot, autonumericOptions)
        // conteggio child

        // conteggio siblings
        const parentID = $currentElement.data('parent-id')
        const siblingsElements = allFields.filter(function () {
            return $(this).data('parent-id') === parentID;
        });
        let siblingsTot = 0
        $.each(siblingsElements, function (i, ob) {
            const cValue = AutoNumeric.getAutoNumericElement(`#${$(ob).attr('id')}`);
            siblingsTot += cValue.getNumber() || 0
        });
        const formattedSiblingsTot = AutoNumeric.format(siblingsTot, autonumericOptions)
        const currentParentElement = allFields.filter(function () {
            return $(this).data('item-id') === parentID;
        })?.first();
        const acCurrentParentElement = AutoNumeric.getAutoNumericElement(`#${currentParentElement.attr('id')}`);
        // conteggio siblings


        // appendo errore
        if (acParentElement && acParentElement.getNumber() < childTot && !$currentElementContainer.hasClass('error-sum')) {
            // errore se i child sono maggiori dell'elemento corrente
            $currentElementContainer.addClass('error').addClass('error-sum')
            $currentElement.after(`<p class=\"inline-errors\">${$currentElement.val()} è inferiore al totale delle sottovoci ${formattedChildTot}</p>`)
            $currentElement.wrap("<div class='field_with_errors'></div>")
        } else if (acCurrentParentElement && acCurrentParentElement.getNumber() < siblingsTot && !$currentElementContainer.hasClass('error-sum')) {
            // errore se i child non ci sono o sono miniori dell'elemento corrente, ma i siblings sono maggiori del parent
            $currentElementContainer.addClass('error').addClass('error-sum')
            $currentElement.after(`<p class=\"inline-errors\">${formattedSiblingsTot} è superiore alla macrovoce ${acCurrentParentElement.getFormatted()}</p>`)
            $currentElement.wrap("<div class='field_with_errors'></div>")
        }

        // loop per eventuali child
        checkChild(allFields, childFields)
    })
}

export { initProjectForm, checkAmount}